import React, {
  useState,
  Fragment,
  useEffect,
  useRef,
  useCallback,
} from "react";
import Checkbox from "@mui/material/Checkbox";
import ClearIcon from "@material-ui/icons/Clear";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import {
  Typography,
  Button,
  IconButton,
  Modal,
  Grid,
  Box,
  TextField,
  Drawer,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider } from "@material-ui/core/styles";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {
  customTheme,
  getColorfont,
  getColor,
} from "../../../StyleComponents/Styledatatable";
import classNames from "classnames";
import ApprovalIcon from "@mui/icons-material/Approval";
import FilterListIcon from "@mui/icons-material/FilterAlt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import axios from "axios";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import useStyles from "../../../StyleComponents/StyleFunctionComponent";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Skeleton from "@material-ui/lab/Skeleton";
import LinearProgress from "@mui/material/LinearProgress";
import CloseIcon from "@mui/icons-material/Close";
import { API_BASE_URL, token, userLevel, adminId } from "../../../../constants";
import BrandTargetReportPopup from "./BrandTargetReportPopup.js";
import dummyBrandTargetResponse from "./brandTargetDummy.json";

// const sourceCodeOptions = [
//   { id: "CC0117P", title: "KG Paid" },
//   { id: "CC0117O", title: "KG Organic" },
//   { id: "CC0117B", title: "KG Branding" },
// ];

// const SocialCampaigns = () => {
//   const [openSidebar, setOpenSidebar] = useState(false);
//   const [filterText, setFilterText] = useState("");
//   const [data, setData] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const loadingRequestsRef = useRef(0);
//   const startLoading = useCallback(() => {
//     loadingRequestsRef.current += 1;
//     setIsLoading(true);
//   }, []);
//   const stopLoading = useCallback(() => {
//     loadingRequestsRef.current = Math.max(loadingRequestsRef.current - 1, 0);
//     if (loadingRequestsRef.current === 0) {
//       setIsLoading(false);
//     }
//   }, []);
//   const [perPage, setPerPage] = useState(50);
//   const [page, setPage] = useState(0);
//   const [totalCount, setTotalCount] = useState(0);
//   const currentDate = new Date();
//   const twoDaysAgo = new Date(currentDate);
//   twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
//   const defaultFromDate = twoDaysAgo.toISOString().split("T")[0];
//   const defaultToDate = currentDate.toISOString().split("T")[0];
//   const [fromDate, setFromDate] = useState(defaultFromDate);
//   const [toDate, setToDate] = useState(defaultToDate);
//   const [selectedState, setSelectedState] = useState();
//   const [stateOptions, setStateOptions] = useState([]);
//   const [selectedBrand, setSelectedBrand] = useState([]);
//   const [brandOptions, setBrandOptions] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [campaignOptions, setCampaignOptions] = useState([]);
//   const [selectedCampaign, setSelectedCampaign] = useState([]);
//   const [moveType, setMoveType] = useState("");
//   const [selectedLeadSource, setSelectedLeadSource] = useState("");
//   const [isVerified, setIsVerified] = useState("");
//   const [selectedModel, setSelectedModel] = useState(null);
//   const [modelOptions, setModelOptions] = useState([]);
//   const [selectedProject, setSelectedProject] = useState(null);
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [editedRows, setEditedRows] = useState({});
//   const [projectOptions, setProjectOptions] = useState([]);
//   const [openConfirmModal, setOpenConfirmModal] = useState(false);
//   const [openViewModal, setOpenViewModal] = useState(false);
//   const [viewRowData, setViewRowData] = useState(null);
//   const [changeBrand, setChangeBrand] = useState(false);
//   const [changeBrandId, setChangeBrandId] = useState(null);
//   const [openBrandTargetPopup, setOpenBrandTargetPopup] = useState(true);

//   const [appliedFilters, setAppliedFilters] = useState({
//     brandIds: [],
//     stateId: null,
//     campaignIds: [],
//     fromDate: defaultFromDate,
//     toDate: defaultToDate,
//     isVerified: "",
//   });
//   const [isDataLoaded, setIsDataLoaded] = useState(false);
//   const [enableMoveAfterFetch, setEnableMoveAfterFetch] = useState(false);
//   const showLeadSource = moveType === "3" &&
//     selectedBrand.some((brand) => [12, 16, 17].includes(Number(brand.id)));

//   const handleViewRow = (rowData) => {
//     setViewRowData(rowData);
//     setOpenViewModal(true);
//   };

//   const handleResetFields = () => {
//     setSnackbarSeverity("success");
//     setSelectedBrand([]);
//     setSelectedModel(null);
//     setSelectedState(null);
//     setSelectedProject(null);
//     setIsVerified("");
//     setMoveType("");
//     setSelectedLeadSource("");
//     setSelectedCampaign([]);
//     setChangeBrand(false);
//     setChangeBrandId(null);
//     setFromDate(defaultFromDate);
//     setToDate(defaultToDate);
//     setSelectedRows([]);
//     setPage(0);
//     setAppliedFilters({
//       brandIds: [],
//       stateId: null,
//       campaignIds: [],
//       fromDate: defaultFromDate,
//       toDate: defaultToDate,
//       isVerified: "",
//     });
//     setIsDataLoaded(false);
//     setEnableMoveAfterFetch(false);
//     setSnackbarMessage("Form fields reset successfully");
//     setSnackbarOpen(true);
//   };

//   const handleDataLoaded = () => {
//     setPage(0);
//     setSelectedRows([]);
//     setEditedRows({});
//     setIsDataLoaded(false);
//     setEnableMoveAfterFetch(true);
//     setAppliedFilters({
//       brandIds: selectedBrand.map((item) => item.id),
//       stateId: selectedState?.id || null,
//       campaignIds: selectedCampaign.map((item) => item.id),
//       fromDate,
//       toDate,
//       isVerified,
//     });
//   };

//   const handleProjectChange = (event, newValue) => {
//     setSelectedProject(newValue);
//   };

//   const handleMoveEnquiryClick = () => {
//     if (!validateMoveEnquiryForm()) {
//       return;
//     }

//     setOpenConfirmModal(true);
//   };

//   const handleConfirmSubmit = async () => {
//     if (!validateMoveEnquiryForm()) {
//       return;
//     }

//     await handleSubmits();
//   };

//   const validateMoveEnquiryForm = () => {
//     if (!selectedBrand || selectedBrand.length === 0) {
//       setSnackbarSeverity("error");
//       setSnackbarMessage("Brand is required");
//       setSnackbarOpen(true);
//       return false;
//     }

//     if (!isVerified) {
//       setSnackbarSeverity("error");
//       setSnackbarMessage("Lead Type is required");
//       setSnackbarOpen(true);
//       return false;
//     }

//     if (!moveType) {
//       setSnackbarSeverity("error");
//       setSnackbarMessage("Move Type is required");
//       setSnackbarOpen(true);
//       return false;
//     }
//     if (selectedRows.length === 0) {
//       setSnackbarSeverity("error");
//       setSnackbarMessage("Please select at least one enquiry");
//       setSnackbarOpen(true);
//       return false;
//     }
//     if (!fromDate) {
//       setSnackbarSeverity("error");
//       setSnackbarMessage("From Date is required");
//       setSnackbarOpen(true);
//       return false;
//     }

//     if (!toDate) {
//       setSnackbarSeverity("error");
//       setSnackbarMessage("To Date is required");
//       setSnackbarOpen(true);
//       return false;
//     }

//     if (new Date(fromDate) > new Date(toDate)) {
//       setSnackbarSeverity("error");
//       setSnackbarMessage("From Date cannot be greater than To Date");
//       setSnackbarOpen(true);
//       return false;
//     }

//     return true;
//   };

//   useEffect(() => {
//     const fetchProjectList = async () => {
//       startLoading();
//       try {
//         const config = {
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//             Authorization: token,
//           },
//         };
//         const response = await axios.post(
//           `${API_BASE_URL}/api/admin/v2/assign-project-brand-list`,
//           {},
//           config,
//         );
//         const projects =
//           response?.data?.data?.data?.map((item) => ({
//             id: item.id,
//             title: item.project_name,
//             brand_id: item.brand_id,
//             brand_name: item.brand_name,
//           })) || [];

//         setProjectOptions(projects);
//       } catch (error) {
//         console.error("Error fetching project list:", error);
//       } finally {
//         stopLoading();
//       }
//     };
//     fetchProjectList();
//   }, [startLoading, stopLoading]);

//   const handleBrandChange = async (event, newValue) => {
//     setSelectedBrand(newValue);
//     setSelectedModel(null);
//     setModelOptions([]);

//     if (!newValue?.length) return;

//     startLoading();
//     try {
//       const config = {
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//           Authorization: token,
//         },
//       };

//       const brandIds = newValue.map((item) => item.id);

//       const response = await axios.post(
//         `${API_BASE_URL}/api/admin/v2/brand-model-list`,
//         {
//           brand_id: brandIds,
//         },
//         config,
//       );

//       const models =
//         response?.data?.data?.map((item) => ({
//           id: item.tractor_model_id,
//           title: item.tractor_model_name,
//         })) || [];

//       setModelOptions(models);
//     } catch (error) {
//       console.error("Error fetching models:", error);
//     } finally {
//       stopLoading();
//     }
//   };

//   useEffect(() => {
//     const fetchCampaignList = async () => {
//       startLoading();
//       try {
//         const config = {
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//             Authorization: `${token}`,
//           },
//         };
//         const response = await axios.post(
//           `${API_BASE_URL}/api/admin/v2/campaign-list`,
//           {},
//           config,
//         );
//         const campaigns =
//           response?.data?.data?.assigned_list?.map((item, index) => ({
//             id: item.id,
//             title: item.campaign_id,
//           })) || [];
//         setCampaignOptions(campaigns);
//       } catch (error) {
//         console.log(error);
//       } finally {
//         stopLoading();
//       }
//     };
//     fetchCampaignList();
//   }, [startLoading, stopLoading]);

//   useEffect(() => {
//     const fetchDatabrand = async () => {
//       startLoading();
//       try {
//         const config = {
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//             Authorization: `${token}`,
//           },
//           timeout: Infinity,
//         };
//         const response = await axios.post(
//           `${API_BASE_URL}/api/admin/v2/brand-list`,
//           config,
//         );
//         const statelist = response.data.data.map((item) => ({
//           id: item.brand_id,
//           title: item.brand_name,
//         }));
//         setBrandOptions(statelist);
//       } catch (error) {
//         console.error("Error fetching state:", error);
//       } finally {
//         stopLoading();
//       }
//     };
//     fetchDatabrand();
//   }, [startLoading, stopLoading]);

//   useEffect(() => {
//     const fetchDatastate = async () => {
//       startLoading();
//       try {
//         const config = {
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//             Authorization: `${token}`,
//           },
//           timeout: Infinity,
//         };
//         const response = await axios.post(
//           `${API_BASE_URL}/api/admin/v2/state-list`,
//           config,
//         );
//         const statelist = response.data.data.map((item) => ({
//           id: item.state_id,
//           title: item.state_name,
//         }));
//         setStateOptions(statelist);
//       } catch (error) {
//         console.error("Error fetching state:", error);
//       } finally {
//         stopLoading();
//       }
//     };
//     fetchDatastate();
//   }, [startLoading, stopLoading]);
//   const handleStateChange = (event, newValue) => {
//     setSelectedState(newValue);
//   };

//   const fetchData = async () => {
//     startLoading();
//     try {
//       const config = {
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//           Authorization: token,
//           adminId: adminId,
//           userLevel: userLevel,
//         },
//       };
//       const payload = {
//         brand_id: appliedFilters.brandIds,
//         state_id: appliedFilters.stateId,
//         campaign_id: appliedFilters.campaignIds,
//         from_date: appliedFilters.fromDate,
//         to_date: appliedFilters.toDate,
//         is_verified: appliedFilters.isVerified || null,
//         pagination: perPage,
//         page: page + 1,
//       };

//       const response = await axios.post(
//         `${API_BASE_URL}/api/admin/v2/socialcampaign-enquiry-list`,
//         payload,
//         config,
//       );
//       const rows =
//         response?.data?.data?.social_campaigns?.map((item, index) => ({
//           id: item.id,
//           serial: page * perPage + index + 1,
//           full_name: `${item.first_name} ${item.last_name}`,
//           mobile: item.mobile,
//           first_name: item.first_name,
//           last_name: item.last_name,
//           campaign_id: item.campaign_id,
//           campaign_name: item.campaign_name,
//           brand_name: item.brand_name,
//           state: item.state,
//           city: item.city,
//           purchase_time: item.purchase_time || "",
//           created_at: new Date(item.created_at).toLocaleString("en-IN"),
//         })) || [];
//       setData(rows);
//       setTotalCount(response.data.data.total);
//       if (enableMoveAfterFetch) {
//         setIsDataLoaded(true);
//         setEnableMoveAfterFetch(false);
//         setSnackbarSeverity("success");
//         setSnackbarMessage("Filtered data loaded successfully");
//         setSnackbarOpen(true);
//       }
//     } catch (error) {
//       console.log(error);
//       setIsDataLoaded(false);
//       setEnableMoveAfterFetch(false);
//       setSnackbarMessage("Failed to fetch data");
//       setSnackbarOpen(true);
//     } finally {
//       stopLoading();
//     }
//   };
//   useEffect(() => {
//     fetchData();
//   }, [page, perPage, appliedFilters]);

//   useEffect(() => {
//     setIsDataLoaded(false);
//     setEnableMoveAfterFetch(false);
//   }, [
//     selectedCampaign,
//     selectedBrand,
//     selectedState,
//     fromDate,
//     toDate,
//     isVerified,
//   ]);

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "fromDate") {
//       setFromDate(value);
//     } else if (name === "toDate") {
//       setToDate(value);
//     }
//   };
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setPage(0);
//     setIsDataLoaded(false);
//     setEnableMoveAfterFetch(false);
//     setAppliedFilters({
//       brandIds: selectedBrand.map((item) => item.id),
//       stateId: selectedState?.id || null,
//       campaignIds: selectedCampaign.map((item) => item.id),
//       fromDate,
//       toDate,
//       isVerified,
//     });
//     setOpenSidebar(false);
//   };
//   const clearForm = () => {
//     setSelectedCampaign([]);
//     setSelectedBrand([]);
//     setSelectedModel(null);
//     setModelOptions([]);
//     setSelectedState(null);
//     setFromDate(defaultFromDate);
//     setToDate(defaultToDate);
//     setIsVerified("");
//     setChangeBrand(false);
//     setChangeBrandId(null);
//     setPage(0);
//     setAppliedFilters({
//       brandIds: [],
//       stateId: null,
//       campaignIds: [],
//       fromDate: defaultFromDate,
//       toDate: defaultToDate,
//       isVerified: "",
//     });
//     setIsDataLoaded(false);
//     setEnableMoveAfterFetch(false);
//     setOpenSidebar(false);
//   };

//   const handleSelectAllCheck = () => {
//     if (selectedRows.length === data.length) {
//       setSelectedRows([]);
//     } else {
//       setSelectedRows(Array.from({ length: data.length }, (_, i) => i));
//     }
//   };
//   const handleRowSelect = (rowIndex) => {
//     if (selectedRows.includes(rowIndex)) {
//       setSelectedRows(selectedRows.filter((row) => row !== rowIndex));
//     } else {
//       setSelectedRows([...selectedRows, rowIndex]);
//     }
//   };

//   const handleSubmits = async () => {
//     if (!validateMoveEnquiryForm()) return;

//     startLoading();
//     try {
//       const config = {
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//           Authorization: `${token}`,
//           adminid: `${adminId}`,
//           userlevel: `${userLevel}`,
//         },
//       };
//       const payload = {
//         move_type: Number(moveType),
//         ...(showLeadSource && { lead_source: selectedLeadSource }),
//         brand_id:
//           selectedBrand?.length > 0 ? selectedBrand.map((item) => item.id) : [],
//         change_brand: changeBrand ? 1 : 0,
//         change_brand_id:
//           changeBrand && changeBrandId ? Number(changeBrandId.id) : null,
//         state_id: selectedState?.id || null,
//         from_date: fromDate,
//         to_date: toDate,
//         project_id: selectedProject?.id || null,
//         is_verified: isVerified || "",
//         model: selectedModel?.title || "",
//         id_selected: selectedRows.map((index) => {
//           const row = {
//             ...data[index],
//             ...(editedRows[index] || {}),
//           };
//           return {
//             id: row.id,
//             first_name: row.first_name || "",
//             last_name: row.last_name || "",
//             mobile: row.mobile || "",
//             state: row.state || "",
//             city: row.city || "",
//             taluka: row.taluka || "",
//             purchase_time: row.purchase_time || "",
//             modelName: row.modelName || "",
//           };
//         }),
//       };

//       const response = await axios.post(
//         `${API_BASE_URL}/api/admin/v2/move-to-brand-campaign-enquiry`,
//         payload,
//         config,
//       );

//       if (
//         response?.data?.status_code === 200 &&
//         response?.data?.error === false
//       ) {
//         setSnackbarSeverity("success");
//         setSnackbarMessage(response.data.message);
//         setSnackbarOpen(true);
//         setSelectedRows([]);
//         await fetchData();
//         setOpenConfirmModal(false);
//       }
//     } catch (error) {
//       setSnackbarSeverity("error");
//       setSnackbarMessage(
//         error?.response?.data?.message || "Something went wrong",
//       );
//       setSnackbarOpen(true);
//     } finally {
//       stopLoading();
//     }
//   };

//   // const fetchBrandTargetReport = useCallback(async (brandId) => {
//   //     const response = await axios.post(
//   //       `${API_BASE_URL}/api/admin/v2/brand-target-report`,
//   //       {
//   //         brand_id: brandId,
//   //       },
//   //       {
//   //         headers: {
//   //           "Content-Type": "application/json",
//   //           Accept: "application/json",
//   //           Authorization: token,
//   //         },
//   //       }
//   //     );

//   //     return response.data.data;
//   //   }, [token]);

// const brandTargetData = dummyBrandTargetResponse.data;

// const targetBrands = brandTargetData.map((brand) => ({
//   id: brand.brand_id,
//   title: brand.brand_name,
//   total_target: brand.total_target,
//   total_generated: brand.lead_counts?.total_generated || 0,
// }));

// const fetchBrandTargetReport = async (brandId) => {
//   const brand = brandTargetData.find(
//     (item) => Number(item.brand_id) === Number(brandId)
//   );

//   if (!brand) {
//     throw new Error("Brand not found");
//   }

//   return mapBrandTargetReport(brand);
// };

//   const columns = [
//     {
//       name: "id",
//       label: (
//         <input
//           type="checkbox"
//           checked={selectedRows.length === data.length && data.length !== 0}
//           onChange={handleSelectAllCheck}
//         />
//       ),
//       options: {
//         filter: false,
//         sort: false,
//         customBodyRender: (value, tableMeta) => (
//           <input
//             type="checkbox"
//             checked={selectedRows.includes(tableMeta.rowIndex)}
//             onChange={() => handleRowSelect(tableMeta.rowIndex)}
//           />
//         ),
//       },
//     },
//     {
//       name: "id",
//       options: {
//         filter: true,
//         setCellProps: () => ({
//           align: "left",
//         }),
//       },
//       label: "S/N",
//     },
//     {
//       name: "brand_name",
//       label: "Brand",
//       options: {
//         filter: false,
//         customBodyRender: (value) =>
//           value && value.trim() !== "" ? (
//             <button
//               className={classes.brandstrip}
//               style={{
//                 backgroundColor: getColor(value),
//                 color: getColorfont(value),
//                 width: "100%",
//               }}
//             >
//               {value}
//             </button>
//           ) : null,
//       },
//     },
//     {
//       name: "modelName",
//       label: "Model Name",
//     },
//     {
//       name: "first_name",
//       label: "First Name",
//     },

//     {
//       name: "last_name",
//       label: "Last Name",
//     },
//     {
//       name: "mobile",
//       label: "Mobile",
//     },
//     {
//       name: "state",
//       label: "State",
//     },
//     {
//       name: "city",
//       label: "City",
//     },
//     {
//       name: "campaign_name",
//       label: "Campaign Name",
//     },
//     {
//       name: "campaign_id",
//       label: "Campaign ID",
//     },
//     {
//       name: "created_at",
//       label: "Date",
//     },
//     {
//       name: "action",
//       label: "Action",
//       options: {
//         filter: false,
//         sort: false,
//         customBodyRenderLite: (dataIndex) => {
//           const rowData = data[dataIndex];

//           return (
//             <IconButton
//               size="small"
//               onClick={() => handleViewRow(rowData)}
//               style={{
//                 color: "#1976d2",
//                 background: "#e3f2fd",
//               }}
//             >
//               <VisibilityIcon />
//             </IconButton>
//           );
//         },
//       },
//     },
//   ];
//   const columnsEdittable = [
//     {
//       name: "id",
//       label: (
//         <input
//           type="checkbox"
//           checked={selectedRows.length === data.length && data.length !== 0}
//           onChange={handleSelectAllCheck}
//         />
//       ),
//       options: {
//         filter: false,
//         sort: false,
//         customBodyRender: (value, tableMeta) => (
//           <input
//             type="checkbox"
//             checked={selectedRows.includes(tableMeta.rowIndex)}
//             onChange={() => handleRowSelect(tableMeta.rowIndex)}
//           />
//         ),
//       },
//     },
//     {
//       name: "id",
//       options: {
//         filter: true,
//         setCellProps: () => ({
//           align: "left",
//         }),
//       },
//       label: "S/N",
//     },
//     {
//       name: "brand_name",
//       label: "Brand",
//       options: {
//         filter: false,
//         customBodyRender: (value) =>
//           value && value.trim() !== "" ? (
//             <button
//               className={classes.brandstrip}
//               style={{
//                 backgroundColor: getColor(value),
//                 color: getColorfont(value),
//                 width: "100%",
//               }}
//             >
//               {value}
//             </button>
//           ) : null,
//       },
//     },
//     {
//       name: "modelName",
//       label: "Model Name",
//       options: {
//         customBodyRender: (value, tableMeta) => {
//           const rowIndex = tableMeta.rowIndex;

//           return (
//             <input
//               placeholder="Enter Model Name"
//               type="text"
//               value={editedRows[rowIndex]?.modelName ?? value ?? ""}
//               onChange={(e) =>
//                 handleCellChange(rowIndex, "modelName", e.target.value)
//               }
//               style={inputStyle}
//             />
//           );
//         },
//       },
//     },
//     {
//       name: "first_name",
//       label: "First Name",
//       options: {
//         customBodyRender: (value, tableMeta) => {
//           const rowIndex = tableMeta.rowIndex;

//           return (
//             <input
//               type="text"
//               value={editedRows[rowIndex]?.first_name ?? value ?? ""}
//               onChange={(e) =>
//                 handleCellChange(rowIndex, "first_name", e.target.value)
//               }
//               style={inputStyle}
//             />
//           );
//         },
//       },
//     },
//     {
//       name: "last_name",
//       label: "Last Name",
//       options: {
//         customBodyRender: (value, tableMeta) => {
//           const rowIndex = tableMeta.rowIndex;

//           return (
//             <input
//               placeholder="Enter Last Name"
//               type="text"
//               value={editedRows[rowIndex]?.last_name ?? value ?? ""}
//               onChange={(e) =>
//                 handleCellChange(rowIndex, "last_name", e.target.value)
//               }
//               style={inputStyle}
//             />
//           );
//         },
//       },
//     },
//     {
//       name: "mobile",
//       label: "Mobile",
//       options: {
//         customBodyRender: (value, tableMeta) => {
//           const rowIndex = tableMeta.rowIndex;

//           return (
//             <input
//               type="text"
//               value={editedRows[rowIndex]?.mobile ?? value ?? ""}
//               onChange={(e) =>
//                 handleCellChange(rowIndex, "mobile", e.target.value)
//               }
//               style={inputStyle}
//             />
//           );
//         },
//       },
//     },
//     {
//       name: "state",
//       label: "State",
//       options: {
//         customBodyRender: (value, tableMeta) => {
//           const rowIndex = tableMeta.rowIndex;

//           return (
//             <input
//               placeholder="Enter State"
//               type="text"
//               value={editedRows[rowIndex]?.state ?? value ?? ""}
//               onChange={(e) =>
//                 handleCellChange(rowIndex, "state", e.target.value)
//               }
//               style={inputStyle}
//             />
//           );
//         },
//       },
//     },
//     {
//       name: "city",
//       label: "City",
//       options: {
//         customBodyRender: (value, tableMeta) => {
//           const rowIndex = tableMeta.rowIndex;

//           return (
//             <input
//               placeholder="Enter City"
//               type="text"
//               value={editedRows[rowIndex]?.city ?? value ?? ""}
//               onChange={(e) =>
//                 handleCellChange(rowIndex, "city", e.target.value)
//               }
//               style={inputStyle}
//             />
//           );
//         },
//       },
//     },
//     {
//       name: "purchase_time",
//       label: "Purchase Time",
//       options: {
//         customBodyRender: (value, tableMeta) => {
//           const rowIndex = tableMeta.rowIndex;

//           return (
//             <input
//               placeholder="Enter Purchase Time"
//               type="number"
//               value={editedRows[rowIndex]?.purchase_time ?? value ?? ""}
//               onChange={(e) =>
//                 handleCellChange(rowIndex, "purchase_time", e.target.value)
//               }
//               style={inputStyle}
//             />
//           );
//         },
//       },
//     },
//     {
//       name: "campaign_id",
//       label: "Campaign ID",
//     },
//     {
//       name: "created_at",
//       label: "Date",
//     },
//   ];

//   const CustomToolbarAction = ({ toggleFilter }) => (
//     <IconButton aria-label="Filter list" onClick={toggleFilter}>
//       <FilterListIcon onClick={toggleSidebar} />
//     </IconButton>
//   );
//   const toggleSidebar = () => {
//     setOpenSidebar(!openSidebar);
//   };

//   const handleRowClick = (rowIndex) => {
//     const isSelected = selectedRows.includes(rowIndex);
//     if (isSelected) {
//       setSelectedRows(selectedRows.filter((row) => row !== rowIndex));
//     } else {
//       setSelectedRows([...selectedRows, rowIndex]);
//     }
//   };

//   const options = {
//     onRowClick: (rowData, rowMeta) => handleRowClick(rowMeta.dataIndex),
//     rowsPerPage: perPage,
//     selectableRows: "none",
//     page: page,
//     serverSide: true,
//     count: totalCount,
//     onTableChange: (action, tableState) => {
//       switch (action) {
//         case "changePage":
//           setPage(tableState.page);
//           break;
//         case "changeRowsPerPage":
//           setPerPage(tableState.rowsPerPage);
//           setPage(0);
//           break;
//         default:
//           break;
//       }
//     },

//     customToolbar: () => <CustomToolbarAction />,
//     filter: false,
//     filterType: "dropdown",
//     responsive: "standard",
//     fixedHeader: true,
//     fixedSelectColumn: true,
//     overflowy: "auto",
//     overflowx: "auto",
//     rowsPerPageOptions: [
//       10,
//       50,
//       100,
//       300,
//       500,
//       1000,
//       10000,
//       { value: totalCount, label: "All" },
//     ],
//     customFilterDialogFooter: (currentFilter, applyNewFilter) => (
//       <div>
//         <TextField
//           label="Filter Data"
//           value={filterText}
//           onChange={(e) => setFilterText(e.target.value)}
//           fullWidth
//         />
//         <Button onClick={applyNewFilter} variant="contained" color="primary">
//           Apply Filter
//         </Button>
//         <Button
//           onClick={() => setOpenSidebar(false)}
//           variant="contained"
//           color="secondary"
//         >
//           Cancel
//         </Button>
//       </div>
//     ),
//     setRowProps: (...[, dataIndex, rowIndex]) => ({
//       style: {
//         backgroundColor: selectedRows.includes(dataIndex)
//           ? "#D2DE32"
//           : "inherit",
//       },
//       onDoubleClick: () => handleRowDoubleClick(rowIndex),
//     }),
//   };
//   const classes = useStyles();

//   const handleRowDoubleClick = (rowIndex) => {
//     const updatedSelectedRows = [...selectedRows];
//     const rowIndexInSelectedRows = updatedSelectedRows.indexOf(rowIndex);
//     if (rowIndexInSelectedRows === -1) {
//       updatedSelectedRows.push(rowIndex);
//     } else {
//       updatedSelectedRows.splice(rowIndexInSelectedRows, 1);
//     }
//     setSelectedRows(updatedSelectedRows);
//   };

//   const handleSelectedRowsCount = () => {
//     return selectedRows.length;
//   };
//   const handleCloseSnackbar = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbarOpen(false);
//   };
//   const handleCellChange = (rowIndex, field, value) => {
//     setEditedRows((prev) => ({
//       ...prev,
//       [rowIndex]: {
//         ...data[rowIndex],
//         ...(prev[rowIndex] || {}),
//         [field]: value,
//       },
//     }));
//   };

//   const exportSelectedRowsToCSV = () => {
//     const selectedData = selectedRows.map((index) => {
//       const row = {
//         ...data[index],
//         ...(editedRows[index] || {}),
//       };

//       return {
//         "First Name": row.first_name || "",
//         "Last Name": row.last_name || "",
//         Mobile: row.mobile || "",
//         State: row.state || "",
//         City: row.city || "",
//         "Campaign ID": row.campaign_id || "",
//         Brand: row.brand_name || "",
//         "Model Name": row.modelName || selectedModel?.title || "",
//         Date: row.created_at || "",
//       };
//     });

//     if (selectedData.length === 0) {
//       setSnackbarMessage("Please select at least one row");
//       setSnackbarOpen(true);
//       return;
//     }

//     const headers = Object.keys(selectedData[0]);

//     const csvRows = [
//       headers.join(","),
//       ...selectedData.map((row) =>
//         headers.map((header) => `"${row[header] ?? ""}"`).join(","),
//       ),
//     ];

//     const csvContent = csvRows.join("\n");

//     const blob = new Blob([csvContent], {
//       type: "text/csv;charset=utf-8;",
//     });

//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.setAttribute(
//       "download",
//       `SocialCampaigns_${new Date().toISOString().split("T")[0]}.csv`,
//     );
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const tableColumns = ["1", "2", "3", "4"].includes(moveType)
//     ? columnsEdittable
//     : columns;

//   useEffect(() => {
//     if (!selectedModel?.title) return;
//     setData((prevData) =>
//       prevData.map((row) => ({
//         ...row,
//         modelName: selectedModel.title,
//       })),
//     );
//   }, [selectedModel]);

//   useEffect(() => {
//     setSelectedRows([]);
//     setEditedRows({});
//   }, [
//     selectedCampaign,
//     selectedBrand,
//     selectedModel,
//     selectedState,
//     selectedProject,
//     isVerified,
//     moveType,
//     fromDate,
//     toDate,
//     page,
//     perPage,
//   ]);
//   return (
//     <>
//       <div>
//         <Snackbar
//           anchorOrigin={{
//             vertical: "top",
//             horizontal: "right",
//           }}
//           open={snackbarOpen}
//           autoHideDuration={6000}
//           onClose={handleCloseSnackbar}
//         >
//           <MuiAlert
//             onClose={handleCloseSnackbar}
//             severity={snackbarSeverity}
//             sx={{ width: "100%" }}
//             variant="filled"
//           >
//             {snackbarMessage}
//           </MuiAlert>
//         </Snackbar>
//       </div>

//       <Box sx={{ width: "100%" }}>
//         <Grid container>
//           <Grid item xs={6} style={{ marginTop: "8px" }}>
//             <Typography
//               className={classNames(
//                 classes.pagetittle,
//                 classes.pagetittlestyle,
//               )}
//             >
//               Social Campaigns Report
//             </Typography>
//           </Grid>
//         </Grid>
//         <hr className={classes.horizontalline} />
//       </Box>
//       <div className={classes.root}>
//         <div className={classes.root}>
//           <Grid container spacing={1} alignItems="center">
//             <Grid item xs={4} sm={2} lg={2}>
//               <input
//                 type="date"
//                 name="fromDate"
//                 value={fromDate}
//                 onChange={handleDateChange}
//                 className={classes.inputform}
//               />
//             </Grid>

//             <Grid item xs={4} sm={2} lg={2}>
//               <input
//                 className={classes.inputform}
//                 type="date"
//                 name="toDate"
//                 value={toDate}
//                 onChange={handleDateChange}
//               />
//             </Grid>

//             <Grid item xs={4} sm={2} lg={4}>
//               <Autocomplete
//                 renderTags={(value) =>
//                   value.map((option) => option.title).join(", ")
//                 }
//                 multiple
//                 classes={{
//                   option: classes.autocompleteoption,
//                 }}
//                 options={brandOptions}
//                 getOptionLabel={(option) => option.title}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     placeholder="Select brand"
//                     variant="outlined"
//                   />
//                 )}
//                 value={selectedBrand}
//                 onChange={handleBrandChange}
//                 disableCloseOnSelect
//                 isOptionEqualToValue={(option, value) => option.id === value.id}
//                 getOptionSelected={(option, value) => option.id === value.id}
//                 renderOption={(props, option, { selected }) => (
//                   <li {...props}>
//                     <Checkbox
//                       checked={selected}
//                       size="small"
//                       style={{ marginRight: 0 }}
//                     />
//                     {option.title}
//                   </li>
//                 )}
//               />
//             </Grid>

//             <Grid item xs={4} sm={2} lg={2}>
//               <Autocomplete
//                 classes={{
//                   option: classes.autocompleteoption,
//                 }}
//                 options={modelOptions}
//                 getOptionLabel={(option) => option.title || ""}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     placeholder="Select Model"
//                     variant="outlined"
//                   />
//                 )}
//                 value={selectedModel}
//                 onChange={(event, newValue) => setSelectedModel(newValue)}
//                 disableCloseOnSelect
//                 isOptionEqualToValue={(option, value) => option.id === value.id}
//                 getOptionSelected={(option, value) => option.id === value.id}
//                 renderOption={(props, option) => (
//                   <li {...props}>{option.title}</li>
//                 )}
//               />
//             </Grid>

//             <Grid item xs={4} sm={2} lg={2}>
//               <Autocomplete
//                 classes={{
//                   option: classes.autocompleteoption,
//                 }}
//                 options={stateOptions}
//                 getOptionLabel={(option) => option.title}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     placeholder="Select State"
//                     variant="outlined"
//                   />
//                 )}
//                 value={selectedState}
//                 onChange={handleStateChange}
//                 disableCloseOnSelect
//                 isOptionEqualToValue={(option, value) => option.id === value.id}
//                 getOptionSelected={(option, value) => option.id === value.id}
//                 renderOption={(props, option, { selected }) => (
//                   <li {...props}>{option.title}</li>
//                 )}
//               />
//             </Grid>
//             <Grid item xs={4} sm={2} lg={2}>
//               <Autocomplete
//                 classes={{
//                   option: classes.autocompleteoption,
//                 }}
//                 options={projectOptions}
//                 getOptionLabel={(option) => option.title || ""}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     placeholder="Select Project Name"
//                     variant="outlined"
//                   />
//                 )}
//                 value={selectedProject}
//                 onChange={handleProjectChange}
//                 disableCloseOnSelect
//                 isOptionEqualToValue={(option, value) => option.id === value.id}
//                 getOptionSelected={(option, value) => option.id === value.id}
//                 renderOption={(props, option) => (
//                   <li {...props}>{option.title}</li>
//                 )}
//               />
//             </Grid>
//             <Grid item xs={4} sm={2} lg={2}>
//               <select
//                 className={classes.selectform}
//                 value={isVerified}
//                 onChange={(e) => setIsVerified(e.target.value)}
//               >
//                 <option value="">Select Lead type</option>
//                 <option value="raw">Raw</option>
//                 <option value="verified">Verified</option>
//               </select>
//             </Grid>
//             <Grid item xs={4} sm={2} lg={2}>
//               <select
//                 className={classes.selectform}
//                 value={moveType}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   setMoveType(value);
//                   if (value !== "3") {
//                     setSelectedLeadSource("");
//                   }
//                 }}
//               >
//                 <option value="">Select Option</option>
//                 <option value="1">Move To All Enquiries</option>
//                 <option value="2">Download and Supplier</option>
//                 <option value="3">Move To API</option>
//               </select>
//             </Grid>
//             {showLeadSource && (
//               <Grid item xs={4} sm={2} lg={2}>
//                 <select
//                   className={classes.selectform}
//                   value={selectedLeadSource}
//                   onChange={(e) => setSelectedLeadSource(e.target.value)}
//                 >
//                   <option value="">Select Lead Source</option>
//                   {sourceCodeOptions.map((option) => (
//                     <option key={option.id} value={option.id}>
//                       {option.title}
//                     </option>
//                   ))}
//                 </select>
//               </Grid>
//             )}

//             <Grid item xs={4} sm={2} lg={2}>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   height: "100%",
//                   minHeight: "40px",
//                 }}
//               >
//                 <Checkbox
//                   checked={changeBrand}
//                   onChange={(e) => {
//                     const checked = e.target.checked;
//                     setChangeBrand(checked);
//                     if (!checked) {
//                       setChangeBrandId(null);
//                     }
//                   }}
//                   size="small"
//                 />
//                 <Typography variant="body2">Change Brand</Typography>
//               </div>
//             </Grid>
//             {changeBrand && (
//               <Grid item xs={4} sm={2} lg={2}>
//                 <Autocomplete
//                   classes={{
//                     option: classes.autocompleteoption,
//                   }}
//                   options={brandOptions}
//                   getOptionLabel={(option) => option.title || ""}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       placeholder="Change Brand To"
//                       variant="outlined"
//                     />
//                   )}
//                   value={changeBrandId}
//                   onChange={(event, newValue) => setChangeBrandId(newValue)}
//                   isOptionEqualToValue={(option, value) => option.id === value.id}
//                   getOptionSelected={(option, value) => option.id === value.id}
//                   renderOption={(props, option) => (
//                     <li {...props}>{option.title}</li>
//                   )}
//                 />
//               </Grid>
//             )}

//             <Grid item xs={12} sm={12} lg={showLeadSource ? 4 : 6}>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "flex-start",
//                   alignItems: "center",
//                   gap: "10px",
//                   width: "100%",
//                   flexWrap: "wrap",
//                 }}
//               >
//                 <Button
//                   onClick={handleResetFields}
//                   variant="outlined"
//                   startIcon={<ClearIcon />}
//                   style={{
//                     backgroundColor: "#dc3545",
//                     borderColor: "#dc3545",
//                   }}
//                   className={classes.buttonform}
//                 >
//                   Reset Fields
//                 </Button>
//                 <Button
//                   onClick={handleDataLoaded}
//                   variant="contained"
//                   startIcon={
//                     isLoading ? (
//                       <CircularProgress size={18} style={{ color: "inherit" }} />
//                     ) : isDataLoaded ? (
//                       <CheckCircleIcon />
//                     ) : (
//                       <CloudDownloadIcon />
//                     )
//                   }
//                   disabled={isLoading}
//                   style={{
//                     backgroundColor: "#1976d2",
//                     borderColor: "#1976d2",
//                     color: "#fff",
//                   }}
//                   className={classes.buttonform}
//                 >
//                   {isLoading
//                     ? "Loading..."
//                     : isDataLoaded
//                       ? "Data Loaded"
//                       : "Get Data"}
//                 </Button>
//                 <Button variant="contained" onClick={() => setOpenBrandTargetPopup(true)} style={{
//                       backgroundColor: "#123d79", color: "#fff", }}>
//                     Brand Target Report
//                 </Button>
//                 <Button
//                   disabled={
//                     isLoading || !isDataLoaded || selectedRows.length === 0
//                   }
//                   onClick={handleMoveEnquiryClick}
//                   style={{ backgroundColor: "#1976d2", borderColor: "#1976d2" }}
//                   className={classes.buttonform}
//                   variant="outlined"
//                   startIcon={<AssignmentIndIcon />}
//                 >
//                   <span>{handleSelectedRowsCount()}</span>-Move Enquiry
//                 </Button>
//               </div>
//             </Grid>
//           </Grid>
//         </div>
//       </div>
//       <br />

//       <MuiThemeProvider theme={customTheme()}>
//         {isLoading ? <LinearProgress /> : ""}
//         <MUIDataTable
//           title={
//             isLoading ? (
//               <Skeleton animation="wave" />
//             ) : (
//               <Typography className={classes.tabletittle}>
//                 {selectedRows.length > 0 && (
//                   <span>Selected Records : {selectedRows.length}</span>
//                 )}
//               </Typography>
//             )
//           }
//           data={data}
//           options={options}
//           columns={tableColumns}
//         />
//       </MuiThemeProvider>
//       <Drawer
//         anchor="right"
//         open={openSidebar}
//         PaperProps={{
//           style: {
//             width: "100%",
//             maxWidth: 300,
//             padding: "10px",
//           },
//         }}
//         onClose={() => setOpenSidebar(false)}
//       >
//         <form onSubmit={handleSubmit}>
//           <Grid container spacing={1}>
//             <Grid
//               item
//               xs={4}
//               sm={2}
//               lg={12}
//               style={{ textAlign: "right", cursor: "pointer" }}
//             >
//               <ClearIcon
//                 style={{ color: "#c0392b" }}
//                 onClick={() => setOpenSidebar(false)}
//               />
//             </Grid>
//             <Grid item xs={4} sm={2} lg={12}>
//               <br />
//               <Typography className={classes.tabletittle}>Filter</Typography>
//             </Grid>
//           </Grid>
//           <div
//             className={classes.root}
//             style={{ paddingRight: "22px", paddingLeft: "22px" }}
//           >
//             <div className={classes.root}>
//               <Grid container spacing={1}>
//                 <Grid item xs={12} sm={12} lg={12}>
//                   <Autocomplete
//                     renderTags={(value) =>
//                       value.map((option) => option.title).join(", ")
//                     }
//                     multiple
//                     classes={{
//                       option: classes.autocompleteoption,
//                     }}
//                     options={campaignOptions}
//                     getOptionLabel={(option) => option.title || ""}
//                     value={selectedCampaign}
//                     onChange={(event, newValue) => {
//                       setSelectedCampaign(newValue);
//                     }}
//                     disableCloseOnSelect
//                     isOptionEqualToValue={(option, value) =>
//                       option.id === value.id
//                     }
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         placeholder="Campaign ID"
//                         variant="outlined"
//                       />
//                     )}
//                     renderOption={(props, option, { selected }) => (
//                       <li {...props}>
//                         <Checkbox
//                           checked={selected}
//                           size="small"
//                           style={{ marginRight: 0 }}
//                         />
//                         {option.title}
//                       </li>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={12} lg={12}>
//                   <Autocomplete
//                     renderTags={(value) =>
//                       value.map((option) => option.title).join(", ")
//                     }
//                     multiple
//                     classes={{
//                       option: classes.autocompleteoption,
//                     }}
//                     options={brandOptions}
//                     getOptionLabel={(option) => option.title}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         placeholder="Select brand"
//                         variant="outlined"
//                       />
//                     )}
//                     value={selectedBrand}
//                     onChange={handleBrandChange}
//                     disableCloseOnSelect
//                     isOptionEqualToValue={(option, value) =>
//                       option.id === value.id
//                     }
//                     getOptionSelected={(option, value) =>
//                       option.id === value.id
//                     }
//                     renderOption={(props, option, { selected }) => (
//                       <li {...props}>
//                         <Checkbox
//                           checked={selected}
//                           size="small"
//                           style={{ marginRight: 0 }}
//                         />
//                         {option.title}
//                       </li>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={12} lg={12}>
//                   <Autocomplete
//                     classes={{
//                       option: classes.autocompleteoption,
//                     }}
//                     options={stateOptions}
//                     getOptionLabel={(option) => option.title}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         placeholder="Select State"
//                         variant="outlined"
//                       />
//                     )}
//                     value={selectedState}
//                     onChange={handleStateChange}
//                     disableCloseOnSelect
//                     isOptionEqualToValue={(option, value) =>
//                       option.id === value.id
//                     }
//                     getOptionSelected={(option, value) =>
//                       option.id === value.id
//                     }
//                     renderOption={(props, option, { selected }) => (
//                       <li {...props}>{option.title}</li>
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <input
//                     className={classes.inputform}
//                     type="date"
//                     name="fromDate"
//                     value={fromDate}
//                     onChange={handleDateChange}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <input
//                     className={classes.inputform}
//                     type="date"
//                     name="toDate"
//                     value={toDate}
//                     onChange={handleDateChange}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <select
//                     className={classes.inputform}
//                     value={isVerified}
//                     onChange={(e) => setIsVerified(e.target.value)}
//                   >
//                     <option value="">Verification</option>
//                     <option value="verified">Verified</option>
//                     <option value="unverified">Unverified</option>
//                   </select>
//                 </Grid>
//               </Grid>
//             </div>
//           </div>
//           <br />
//           <Grid>
//             <Grid
//               item
//               xs={4}
//               sm={2}
//               lg={12}
//               style={{ margin: "auto", padding: "auto", textAlign: "center" }}
//             >
//               <Button
//                 type="submit"
//                 style={{ marginRight: "10px" }}
//                 className={classes.buttonform}
//                 variant="outlined"
//                 startIcon={<ApprovalIcon />}
//               >
//                 Apply
//               </Button>
//               <Button
//                 type="button"
//                 onClick={clearForm}
//                 style={{ backgroundColor: "#dc3545", borderColor: "#dc3545" }}
//                 className={classes.buttonform}
//                 variant="outlined"
//                 startIcon={<ClearIcon />}
//               >
//                 Clear
//               </Button>
//             </Grid>
//           </Grid>
//           <br />
//         </form>
//       </Drawer>
//       <Modal open={openConfirmModal} onClose={() => setOpenConfirmModal(false)}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             bgcolor: "background.paper",
//             p: 3,
//             borderRadius: 2,
//             minWidth: 450,
//             textAlign: "center",
//             boxShadow: 24,
//           }}
//         >
//           <Typography
//             variant="h6"
//             gutterBottom
//             style={{
//               fontWeight: 600,
//               color: "#1976d2",
//             }}
//           >
//             Move To Enquiry Confirmation
//           </Typography>
//           <Typography
//             variant="body1"
//             style={{
//               marginBottom: "20px",
//             }}
//           >
//             Are you sure you want to move
//             <b> {selectedRows.length} </b>
//             selected enquiry records?
//           </Typography>

//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               gap: "10px",
//               flexWrap: "wrap",
//             }}
//           >
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={handleConfirmSubmit}
//               disabled={isLoading}
//             >
//               {isLoading ? "Processing..." : "Yes, Move Enquiry"}
//             </Button>

//             <Button
//               variant="contained"
//               style={{
//                 backgroundColor: "#28a745",
//                 color: "#fff",
//               }}
//               onClick={() => {
//                 exportSelectedRowsToCSV();
//                 setOpenConfirmModal(false);
//               }}
//             >
//               Export Selected CSV
//             </Button>

//             <Button
//               variant="outlined"
//               color="secondary"
//               onClick={() => setOpenConfirmModal(false)}
//             >
//               Cancel
//             </Button>
//           </div>
//         </Box>
//       </Modal>
//       {/* @@@@@@@@@@@@@@@@@@@@@@@ view model start */}
//       <Modal open={openViewModal} onClose={() => setOpenViewModal(false)}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             bgcolor: "#fff",
//             p: 3,
//             borderRadius: 2,
//             width: 900,
//             height: "95vh",
//             overflowY: "auto",
//             boxShadow: 24,
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               marginBottom: "20px",
//               borderBottom: "1px solid #e0e0e0",
//               paddingBottom: "10px",
//             }}
//           >
//             <Typography
//               variant="h6"
//               style={{
//                 fontWeight: 600,
//                 color: "#1976d2",
//                 margin: 0,
//               }}
//             >
//               Enquiry Details
//             </Typography>

//             <IconButton
//               onClick={() => setOpenViewModal(false)}
//               size="small"
//               style={{
//                 color: "#f44336",
//                 backgroundColor: "#f5f5f5",
//               }}
//             >
//               <CloseIcon />
//             </IconButton>
//           </div>

//           {viewRowData && (
//             <Grid container spacing={2}>
//               <Grid item xs={6}>
//                 <span className={classes.breadcrumbslinkHightlight}>
//                   First Name <span>:</span>
//                 </span>{" "}
//                 {viewRowData.first_name}
//               </Grid>

//               <Grid item xs={6}>
//                 <span className={classes.breadcrumbslinkHightlight}>
//                   Last Name <span>:</span>
//                 </span>{" "}
//                 {viewRowData.last_name}
//               </Grid>

//               <Grid item xs={6}>
//                 <span className={classes.breadcrumbslinkHightlight}>
//                   Mobile <span>:</span>
//                 </span>{" "}
//                 {viewRowData.mobile}
//               </Grid>

//               <Grid item xs={6}>
//                 <span className={classes.breadcrumbslinkHightlight}>
//                   Brand <span>:</span>
//                 </span>{" "}
//                 {viewRowData.brand_name}
//               </Grid>

//               <Grid item xs={6}>
//                 <span className={classes.breadcrumbslinkHightlight}>
//                   State <span>:</span>
//                 </span>{" "}
//                 {viewRowData.state}
//               </Grid>

//               <Grid item xs={6}>
//                 <span className={classes.breadcrumbslinkHightlight}>
//                   City <span>:</span>
//                 </span>{" "}
//                 {viewRowData.city}
//               </Grid>

//               <Grid item xs={12}>
//                 <span className={classes.breadcrumbslinkHightlight}>
//                   Source <span>:</span>
//                 </span>{" "}
//                 FBE
//               </Grid>

//               <Grid item xs={6}>
//                 <span className={classes.breadcrumbslinkHightlight}>
//                   Date <span>:</span>
//                 </span>{" "}
//                 {viewRowData.created_at}
//               </Grid>
//             </Grid>
//           )}
//         </Box>
//       </Modal>
//       {/* @@@@@@@@@@@@@@@@@@@@@@@ view model end */}
        
//       <BrandTargetReportPopup
//         open={openBrandTargetPopup}
//         onClose={() => setOpenBrandTargetPopup(false)}
//         reportData={dummyBrandTargetResponse}
//       />

//     </>
//   );
// };

// export default SocialCampaigns;
// const inputStyle = {
//   width: "100%",
//   minWidth: "150px",
//   boxSizing: "border-box",
//   padding: "8px",
//   border: "1px solid #ccc",
//   borderRadius: "4px",
// };

const sourceCodeOptions = [

  { id: "CC0117P", title: "KG Paid" },

  { id: "CC0117O", title: "KG Organic" },

  { id: "CC0117B", title: "KG Branding" },

];

const SocialCampaigns = () => {

  const [openSidebar, setOpenSidebar] = useState(false);

  const [filterText, setFilterText] = useState("");

  const [data, setData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const loadingRequestsRef = useRef(0);

  const startLoading = useCallback(() => {

    loadingRequestsRef.current += 1;

    setIsLoading(true);

  }, []);

  const stopLoading = useCallback(() => {

    loadingRequestsRef.current = Math.max(loadingRequestsRef.current - 1, 0);

    if (loadingRequestsRef.current === 0) {

      setIsLoading(false);

    }

  }, []);

  const [perPage, setPerPage] = useState(50);

  const [page, setPage] = useState(0);

  const [totalCount, setTotalCount] = useState(0);

  const currentDate = new Date();

  const twoDaysAgo = new Date(currentDate);

  twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);

  const defaultFromDate = twoDaysAgo.toISOString().split("T")[0];

  const defaultToDate = currentDate.toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(defaultFromDate);

  const [toDate, setToDate] = useState(defaultToDate);

  const [selectedState, setSelectedState] = useState();

  const [stateOptions, setStateOptions] = useState([]);

  const [selectedBrand, setSelectedBrand] = useState([]);

  const [brandOptions, setBrandOptions] = useState([]);

  const [selectedRows, setSelectedRows] = useState([]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [campaignOptions, setCampaignOptions] = useState([]);

  const [selectedCampaign, setSelectedCampaign] = useState([]);

  const [moveType, setMoveType] = useState("");
  const [isLoan, setIsLoan] = useState(false);
  const [loanType, setLoanType] = useState("");
  const [clientName, setClientName] = useState("");

  const [selectedLeadSource, setSelectedLeadSource] = useState("");

  const [isVerified, setIsVerified] = useState("");

  const [selectedModel, setSelectedModel] = useState(null);

  const [modelOptions, setModelOptions] = useState([]);

  const [selectedProject, setSelectedProject] = useState(null);

  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [editedRows, setEditedRows] = useState({});

  const [projectOptions, setProjectOptions] = useState([]);

  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const [openViewModal, setOpenViewModal] = useState(false);

  const [viewRowData, setViewRowData] = useState(null);

  const [changeBrand, setChangeBrand] = useState(false);

  const [changeBrandId, setChangeBrandId] = useState(null);

  const [openBrandTargetPopup, setOpenBrandTargetPopup] = useState(true);
  const [brandTargetResponse, setBrandTargetResponse] = useState({ data: [] });
  const [brandTargetLoading, setBrandTargetLoading] = useState(false);
  const [brandTargetError, setBrandTargetError] = useState("");



  const [appliedFilters, setAppliedFilters] = useState({

    brandIds: [],

    stateId: null,

    campaignIds: [],

    fromDate: defaultFromDate,

    toDate: defaultToDate,

    isVerified: "",

  });

  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [enableMoveAfterFetch, setEnableMoveAfterFetch] = useState(false);

  const showLeadSource = moveType === "3" &&

    selectedBrand.some((brand) => [12, 16, 17].includes(Number(brand.id)));



  const handleViewRow = (rowData) => {

    setViewRowData(rowData);

    setOpenViewModal(true);

  };



  const handleResetFields = () => {

    setSnackbarSeverity("success");

    setSelectedBrand([]);

    setSelectedModel(null);

    setSelectedState(null);

    setSelectedProject(null);

    setIsVerified("");

    setMoveType("");
    setIsLoan(false);
    setLoanType("");
    setClientName("");

    setSelectedLeadSource("");

    setSelectedCampaign([]);

    setChangeBrand(false);

    setChangeBrandId(null);

    setFromDate(defaultFromDate);

    setToDate(defaultToDate);

    setSelectedRows([]);

    setPage(0);

    setAppliedFilters({

      brandIds: [],

      stateId: null,

      campaignIds: [],

      fromDate: defaultFromDate,

      toDate: defaultToDate,

      isVerified: "",

    });

    setIsDataLoaded(false);

    setEnableMoveAfterFetch(false);

    setSnackbarMessage("Form fields reset successfully");

    setSnackbarOpen(true);

  };



  const handleDataLoaded = () => {

    setPage(0);

    setSelectedRows([]);

    setEditedRows({});

    setIsDataLoaded(false);

    setEnableMoveAfterFetch(true);

    setAppliedFilters({

      brandIds: selectedBrand.map((item) => item.id),

      stateId: selectedState?.id || null,

      campaignIds: selectedCampaign.map((item) => item.id),

      fromDate,

      toDate,

      isVerified,

    });

  };



  const handleProjectChange = (event, newValue) => {

    setSelectedProject(newValue);

  };



  const handleMoveEnquiryClick = () => {

    if (!validateMoveEnquiryForm()) {

      return;

    }



    setOpenConfirmModal(true);

  };



  const handleConfirmSubmit = async () => {

    if (!validateMoveEnquiryForm()) {

      return;

    }



    await handleSubmits();

  };



  const validateMoveEnquiryForm = () => {

    if (!selectedBrand || selectedBrand.length === 0) {

      setSnackbarSeverity("error");

      setSnackbarMessage("Brand is required");

      setSnackbarOpen(true);

      return false;

    }



    if (!isVerified) {

      setSnackbarSeverity("error");

      setSnackbarMessage("Lead Type is required");

      setSnackbarOpen(true);

      return false;

    }



    if (!moveType) {

      setSnackbarSeverity("error");

      setSnackbarMessage("Move Type is required");

      setSnackbarOpen(true);

      return false;

    }

    if (moveType === "3" && isLoan && (!loanType || !clientName)) {
      setSnackbarSeverity("error");
      setSnackbarMessage("Please select Loan Type and Client Name");
      setSnackbarOpen(true);
      return false;
    }
    if (selectedRows.length === 0) {

      setSnackbarSeverity("error");

      setSnackbarMessage("Please select at least one enquiry");

      setSnackbarOpen(true);

      return false;

    }

    if (!fromDate) {

      setSnackbarSeverity("error");

      setSnackbarMessage("From Date is required");

      setSnackbarOpen(true);

      return false;

    }



    if (!toDate) {

      setSnackbarSeverity("error");

      setSnackbarMessage("To Date is required");

      setSnackbarOpen(true);

      return false;

    }



    if (new Date(fromDate) > new Date(toDate)) {

      setSnackbarSeverity("error");

      setSnackbarMessage("From Date cannot be greater than To Date");

      setSnackbarOpen(true);

      return false;

    }



    return true;

  };



  useEffect(() => {

    const fetchProjectList = async () => {

      startLoading();

      try {

        const config = {

          headers: {

            "Content-Type": "application/json",

            Accept: "application/json",

            Authorization: token,

          },

        };

        const response = await axios.post(

          `${API_BASE_URL}/api/admin/v2/assign-project-brand-list`,

          {},

          config,

        );

        const projects =

          response?.data?.data?.data?.map((item) => ({

            id: item.id,

            title: item.project_name,

            brand_id: item.brand_id,

            brand_name: item.brand_name,

          })) || [];



        setProjectOptions(projects);

      } catch (error) {

        console.error("Error fetching project list:", error);

      } finally {

        stopLoading();

      }

    };

    fetchProjectList();

  }, [startLoading, stopLoading]);



  const handleBrandChange = async (event, newValue) => {

    setSelectedBrand(newValue);

    setSelectedModel(null);

    setModelOptions([]);



    if (!newValue?.length) return;



    startLoading();

    try {

      const config = {

        headers: {

          "Content-Type": "application/json",

          Accept: "application/json",

          Authorization: token,

        },

      };



      const brandIds = newValue.map((item) => item.id);



      const response = await axios.post(

        `${API_BASE_URL}/api/admin/v2/brand-model-list`,

        {

          brand_id: brandIds,

        },

        config,

      );



      const models =

        response?.data?.data?.map((item) => ({

          id: item.tractor_model_id,

          title: item.tractor_model_name,

        })) || [];



      setModelOptions(models);

    } catch (error) {

      console.error("Error fetching models:", error);

    } finally {

      stopLoading();

    }

  };



  useEffect(() => {

    const fetchCampaignList = async () => {

      startLoading();

      try {

        const config = {

          headers: {

            "Content-Type": "application/json",

            Accept: "application/json",

            Authorization: `${token}`,

          },

        };

        const response = await axios.post(

          `${API_BASE_URL}/api/admin/v2/campaign-list`,

          {},

          config,

        );

        const campaigns =

          response?.data?.data?.assigned_list?.map((item, index) => ({

            id: item.id,

            title: item.campaign_id,

          })) || [];

        setCampaignOptions(campaigns);

      } catch (error) {

        console.log(error);

      } finally {

        stopLoading();

      }

    };

    fetchCampaignList();

  }, [startLoading, stopLoading]);



  useEffect(() => {

    const fetchDatabrand = async () => {

      startLoading();

      try {

        const config = {

          headers: {

            "Content-Type": "application/json",

            Accept: "application/json",

            Authorization: `${token}`,

          },

          timeout: Infinity,

        };

        const response = await axios.post(

          `${API_BASE_URL}/api/admin/v2/brand-list`,

          config,

        );

        const statelist = response.data.data.map((item) => ({

          id: item.brand_id,

          title: item.brand_name,

        }));

        setBrandOptions(statelist);

      } catch (error) {

        console.error("Error fetching state:", error);

      } finally {

        stopLoading();

      }

    };

    fetchDatabrand();

  }, [startLoading, stopLoading]);



  useEffect(() => {

    const fetchDatastate = async () => {

      startLoading();

      try {

        const config = {

          headers: {

            "Content-Type": "application/json",

            Accept: "application/json",

            Authorization: `${token}`,

          },

          timeout: Infinity,

        };

        const response = await axios.post(

          `${API_BASE_URL}/api/admin/v2/state-list`,

          config,

        );

        const statelist = response.data.data.map((item) => ({

          id: item.state_id,

          title: item.state_name,

        }));

        setStateOptions(statelist);

      } catch (error) {

        console.error("Error fetching state:", error);

      } finally {

        stopLoading();

      }

    };

    fetchDatastate();

  }, [startLoading, stopLoading]);

  const handleStateChange = (event, newValue) => {

    setSelectedState(newValue);

  };



  const fetchData = async () => {

    startLoading();

    try {

      const config = {

        headers: {

          "Content-Type": "application/json",

          Accept: "application/json",

          Authorization: token,

          adminId: adminId,

          userLevel: userLevel,

        },

      };

      const payload = {

        brand_id: appliedFilters.brandIds,

        state_id: appliedFilters.stateId,

        campaign_id: appliedFilters.campaignIds,

        from_date: appliedFilters.fromDate,

        to_date: appliedFilters.toDate,

        is_verified: appliedFilters.isVerified || null,

        pagination: perPage,

        page: page + 1,

      };



      const response = await axios.post(

        `${API_BASE_URL}/api/admin/v2/socialcampaign-enquiry-list`,

        payload,

        config,

      );

      const rows =

        response?.data?.data?.social_campaigns?.map((item, index) => ({

          id: item.id,

          serial: page * perPage + index + 1,

          full_name: `${item.first_name} ${item.last_name}`,

          mobile: item.mobile,

          first_name: item.first_name,

          last_name: item.last_name,

          campaign_id: item.campaign_id,

          campaign_name: item.campaign_name,

          brand_name: item.brand_name,

          state: item.state,

          city: item.city,

          purchase_time: item.purchase_time || "",

          created_at: new Date(item.created_at).toLocaleString("en-IN"),

        })) || [];

      setData(rows);

      setTotalCount(response.data.data.total);

      if (enableMoveAfterFetch) {

        setIsDataLoaded(true);

        setEnableMoveAfterFetch(false);

        setSnackbarSeverity("success");

        setSnackbarMessage("Filtered data loaded successfully");

        setSnackbarOpen(true);

      }

    } catch (error) {

      console.log(error);

      setIsDataLoaded(false);

      setEnableMoveAfterFetch(false);

      setSnackbarMessage("Failed to fetch data");

      setSnackbarOpen(true);

    } finally {

      stopLoading();

    }

  };

  useEffect(() => {

    fetchData();

  }, [page, perPage, appliedFilters]);



  useEffect(() => {

    setIsDataLoaded(false);

    setEnableMoveAfterFetch(false);

  }, [

    selectedCampaign,

    selectedBrand,

    selectedState,

    fromDate,

    toDate,

    isVerified,

  ]);



  const handleDateChange = (e) => {

    const { name, value } = e.target;

    if (name === "fromDate") {

      setFromDate(value);

    } else if (name === "toDate") {

      setToDate(value);

    }

  };

  const handleSubmit = (e) => {

    e.preventDefault();

    setPage(0);

    setIsDataLoaded(false);

    setEnableMoveAfterFetch(false);

    setAppliedFilters({

      brandIds: selectedBrand.map((item) => item.id),

      stateId: selectedState?.id || null,

      campaignIds: selectedCampaign.map((item) => item.id),

      fromDate,

      toDate,

      isVerified,

    });

    setOpenSidebar(false);

  };

  const clearForm = () => {

    setSelectedCampaign([]);

    setSelectedBrand([]);

    setSelectedModel(null);

    setModelOptions([]);

    setSelectedState(null);

    setFromDate(defaultFromDate);

    setToDate(defaultToDate);

    setIsVerified("");

    setChangeBrand(false);

    setChangeBrandId(null);

    setPage(0);

    setAppliedFilters({

      brandIds: [],

      stateId: null,

      campaignIds: [],

      fromDate: defaultFromDate,

      toDate: defaultToDate,

      isVerified: "",

    });

    setIsDataLoaded(false);

    setEnableMoveAfterFetch(false);

    setOpenSidebar(false);

  };



  const handleSelectAllCheck = () => {

    if (selectedRows.length === data.length) {

      setSelectedRows([]);

    } else {

      setSelectedRows(Array.from({ length: data.length }, (_, i) => i));

    }

  };

  const handleRowSelect = (rowIndex) => {

    if (selectedRows.includes(rowIndex)) {

      setSelectedRows(selectedRows.filter((row) => row !== rowIndex));

    } else {

      setSelectedRows([...selectedRows, rowIndex]);

    }

  };



  const handleSubmits = async () => {

    if (!validateMoveEnquiryForm()) return;



    startLoading();

    try {

      const config = {

        headers: {

          "Content-Type": "application/json",

          Accept: "application/json",

          Authorization: `${token}`,

          adminid: `${adminId}`,

          userlevel: `${userLevel}`,

        },

      };

      const payload = {

        move_type: Number(moveType),
      ...(moveType === "3" && isLoan && { is_loan: 1, loan_type: loanType, client_name: clientName }),

        ...(showLeadSource && { lead_source: selectedLeadSource }),

        brand_id:

          selectedBrand?.length > 0 ? selectedBrand.map((item) => item.id) : [],

        change_brand: changeBrand ? 1 : 0,

        change_brand_id:

          changeBrand && changeBrandId ? Number(changeBrandId.id) : null,

        state_id: selectedState?.id || null,

        from_date: fromDate,

        to_date: toDate,

        project_id: selectedProject?.id || null,

        is_verified: isVerified || "",

        model: selectedModel?.title || "",

        id_selected: selectedRows.map((index) => {

          const row = {

            ...data[index],

            ...(editedRows[index] || {}),

          };

          return {

            id: row.id,

            first_name: row.first_name || "",

            last_name: row.last_name || "",

            mobile: row.mobile || "",

            state: row.state || "",

            city: row.city || "",

            taluka: row.taluka || "",

            purchase_time: row.purchase_time || "",

            modelName: row.modelName || "",

          };

        }),

      };



      const response = await axios.post(

        `${API_BASE_URL}/api/admin/v2/move-to-brand-campaign-enquiry`,

        payload,

        config,

      );



      if (

        response?.data?.status_code === 200 &&

        response?.data?.error === false

      ) {

        setSnackbarSeverity("success");

        setSnackbarMessage(response.data.message);

        setSnackbarOpen(true);

        setSelectedRows([]);

        await fetchData();

        setOpenConfirmModal(false);

      }

    } catch (error) {

      setSnackbarSeverity("error");

      setSnackbarMessage(

        error?.response?.data?.message || "Something went wrong",

      );

      setSnackbarOpen(true);

    } finally {

      stopLoading();

    }

  };



  // const fetchBrandTargetReport = useCallback(async (brandId) => {

  //     const response = await axios.post(

  //       `${API_BASE_URL}/api/admin/v2/brand-target-report`,

  //       {

  //         brand_id: brandId,

  //       },

  //       {

  //         headers: {

  //           "Content-Type": "application/json",

  //           Accept: "application/json",

  //           Authorization: token,

  //         },

  //       }

  //     );



  //     return response.data.data;

  //   }, [token]);



// Load the current brand target report when the popup is opened.
useEffect(() => {
  if (!openBrandTargetPopup) return;
  let active = true;
  const loadBrandTargets = async () => {
    setBrandTargetLoading(true);
    setBrandTargetError("");
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/admin/v2/today-target-popup`,
        {},
        { headers: { "Content-Type": "application/json", Accept: "application/json", Authorization: token } }
      );
      if (active) {
        const body = response.data;
        const raw = body?.data;
        const brands = Array.isArray(raw) ? raw
          : Array.isArray(raw?.data) ? raw.data
          : Array.isArray(raw?.brands) ? raw.brands
          : Array.isArray(raw?.brand_targets) ? raw.brand_targets
          : Array.isArray(body?.brands) ? body.brands
          : [];
        setBrandTargetResponse({ data: brands });
        if (!brands.length) setBrandTargetError("No brand target data returned by the API.");
      }
    } catch (error) {
      if (active) {
        setBrandTargetResponse({ data: [] });
        setBrandTargetError(error?.response?.data?.message || "Unable to load brand targets");
      }
    } finally {
      if (active) setBrandTargetLoading(false);
    }
  };
  loadBrandTargets();
  return () => { active = false; };
}, [openBrandTargetPopup]);

  const columns = [

    {

      name: "id",

      label: (

        <input

          type="checkbox"

          checked={selectedRows.length === data.length && data.length !== 0}

          onChange={handleSelectAllCheck}

        />

      ),

      options: {

        filter: false,

        sort: false,

        customBodyRender: (value, tableMeta) => (

          <input

            type="checkbox"

            checked={selectedRows.includes(tableMeta.rowIndex)}

            onChange={() => handleRowSelect(tableMeta.rowIndex)}

          />

        ),

      },

    },

    {

      name: "id",

      options: {

        filter: true,

        setCellProps: () => ({

          align: "left",

        }),

      },

      label: "S/N",

    },

    {

      name: "brand_name",

      label: "Brand",

      options: {

        filter: false,

        customBodyRender: (value) =>

          value && value.trim() !== "" ? (

            <button

              className={classes.brandstrip}

              style={{

                backgroundColor: getColor(value),

                color: getColorfont(value),

                width: "100%",

              }}

            >

              {value}

            </button>

          ) : null,

      },

    },

    {

      name: "modelName",

      label: "Model Name",

    },

    {

      name: "first_name",

      label: "First Name",

    },



    {

      name: "last_name",

      label: "Last Name",

    },

    {

      name: "mobile",

      label: "Mobile",

    },

    {

      name: "state",

      label: "State",

    },

    {

      name: "city",

      label: "City",

    },

    {

      name: "campaign_name",

      label: "Campaign Name",

    },

    {

      name: "campaign_id",

      label: "Campaign ID",

    },

    {

      name: "created_at",

      label: "Date",

    },

    {

      name: "action",

      label: "Action",

      options: {

        filter: false,

        sort: false,

        customBodyRenderLite: (dataIndex) => {

          const rowData = data[dataIndex];



          return (

            <IconButton

              size="small"

              onClick={() => handleViewRow(rowData)}

              style={{

                color: "#1976d2",

                background: "#e3f2fd",

              }}

            >

              <VisibilityIcon />

            </IconButton>

          );

        },

      },

    },

  ];

  const columnsEdittable = [

    {

      name: "id",

      label: (

        <input

          type="checkbox"

          checked={selectedRows.length === data.length && data.length !== 0}

          onChange={handleSelectAllCheck}

        />

      ),

      options: {

        filter: false,

        sort: false,

        customBodyRender: (value, tableMeta) => (

          <input

            type="checkbox"

            checked={selectedRows.includes(tableMeta.rowIndex)}

            onChange={() => handleRowSelect(tableMeta.rowIndex)}

          />

        ),

      },

    },

    {

      name: "id",

      options: {

        filter: true,

        setCellProps: () => ({

          align: "left",

        }),

      },

      label: "S/N",

    },

    {

      name: "brand_name",

      label: "Brand",

      options: {

        filter: false,

        customBodyRender: (value) =>

          value && value.trim() !== "" ? (

            <button

              className={classes.brandstrip}

              style={{

                backgroundColor: getColor(value),

                color: getColorfont(value),

                width: "100%",

              }}

            >

              {value}

            </button>

          ) : null,

      },

    },

    {

      name: "modelName",

      label: "Model Name",

      options: {

        customBodyRender: (value, tableMeta) => {

          const rowIndex = tableMeta.rowIndex;



          return (

            <input

              placeholder="Enter Model Name"

              type="text"

              value={editedRows[rowIndex]?.modelName ?? value ?? ""}

              onChange={(e) =>

                handleCellChange(rowIndex, "modelName", e.target.value)

              }

              style={inputStyle}

            />

          );

        },

      },

    },

    {

      name: "first_name",

      label: "First Name",

      options: {

        customBodyRender: (value, tableMeta) => {

          const rowIndex = tableMeta.rowIndex;



          return (

            <input

              type="text"

              value={editedRows[rowIndex]?.first_name ?? value ?? ""}

              onChange={(e) =>

                handleCellChange(rowIndex, "first_name", e.target.value)

              }

              style={inputStyle}

            />

          );

        },

      },

    },

    {

      name: "last_name",

      label: "Last Name",

      options: {

        customBodyRender: (value, tableMeta) => {

          const rowIndex = tableMeta.rowIndex;



          return (

            <input

              placeholder="Enter Last Name"

              type="text"

              value={editedRows[rowIndex]?.last_name ?? value ?? ""}

              onChange={(e) =>

                handleCellChange(rowIndex, "last_name", e.target.value)

              }

              style={inputStyle}

            />

          );

        },

      },

    },

    {

      name: "mobile",

      label: "Mobile",

      options: {

        customBodyRender: (value, tableMeta) => {

          const rowIndex = tableMeta.rowIndex;



          return (

            <input

              type="text"

              value={editedRows[rowIndex]?.mobile ?? value ?? ""}

              onChange={(e) =>

                handleCellChange(rowIndex, "mobile", e.target.value)

              }

              style={inputStyle}

            />

          );

        },

      },

    },

    {

      name: "state",

      label: "State",

      options: {

        customBodyRender: (value, tableMeta) => {

          const rowIndex = tableMeta.rowIndex;



          return (

            <input

              placeholder="Enter State"

              type="text"

              value={editedRows[rowIndex]?.state ?? value ?? ""}

              onChange={(e) =>

                handleCellChange(rowIndex, "state", e.target.value)

              }

              style={inputStyle}

            />

          );

        },

      },

    },

    {

      name: "city",

      label: "City",

      options: {

        customBodyRender: (value, tableMeta) => {

          const rowIndex = tableMeta.rowIndex;



          return (

            <input

              placeholder="Enter City"

              type="text"

              value={editedRows[rowIndex]?.city ?? value ?? ""}

              onChange={(e) =>

                handleCellChange(rowIndex, "city", e.target.value)

              }

              style={inputStyle}

            />

          );

        },

      },

    },

    {

      name: "purchase_time",

      label: "Purchase Time",

      options: {

        customBodyRender: (value, tableMeta) => {

          const rowIndex = tableMeta.rowIndex;



          return (

            <input

              placeholder="Enter Purchase Time"

              type="number"

              value={editedRows[rowIndex]?.purchase_time ?? value ?? ""}

              onChange={(e) =>

                handleCellChange(rowIndex, "purchase_time", e.target.value)

              }

              style={inputStyle}

            />

          );

        },

      },

    },

    {

      name: "campaign_id",

      label: "Campaign ID",

    },

    {

      name: "created_at",

      label: "Date",

    },

  ];



  const CustomToolbarAction = ({ toggleFilter }) => (

    <IconButton aria-label="Filter list" onClick={toggleFilter}>

      <FilterListIcon onClick={toggleSidebar} />

    </IconButton>

  );

  const toggleSidebar = () => {

    setOpenSidebar(!openSidebar);

  };



  const handleRowClick = (rowIndex) => {

    const isSelected = selectedRows.includes(rowIndex);

    if (isSelected) {

      setSelectedRows(selectedRows.filter((row) => row !== rowIndex));

    } else {

      setSelectedRows([...selectedRows, rowIndex]);

    }

  };



  const options = {

    onRowClick: (rowData, rowMeta) => handleRowClick(rowMeta.dataIndex),

    rowsPerPage: perPage,

    selectableRows: "none",

    page: page,

    serverSide: true,

    count: totalCount,

    onTableChange: (action, tableState) => {

      switch (action) {

        case "changePage":

          setPage(tableState.page);

          break;

        case "changeRowsPerPage":

          setPerPage(tableState.rowsPerPage);

          setPage(0);

          break;

        default:

          break;

      }

    },



    customToolbar: () => <CustomToolbarAction />,

    filter: false,

    filterType: "dropdown",

    responsive: "standard",

    fixedHeader: true,

    fixedSelectColumn: true,

    overflowy: "auto",

    overflowx: "auto",

    rowsPerPageOptions: [

      10,

      50,

      100,

      300,

      500,

      1000,

      10000,

      { value: totalCount, label: "All" },

    ],

    customFilterDialogFooter: (currentFilter, applyNewFilter) => (

      <div>

        <TextField

          label="Filter Data"

          value={filterText}

          onChange={(e) => setFilterText(e.target.value)}

          fullWidth

        />

        <Button onClick={applyNewFilter} variant="contained" color="primary">

          Apply Filter

        </Button>

        <Button

          onClick={() => setOpenSidebar(false)}

          variant="contained"

          color="secondary"

        >

          Cancel

        </Button>

      </div>

    ),

    setRowProps: (...[, dataIndex, rowIndex]) => ({

      style: {

        backgroundColor: selectedRows.includes(dataIndex)

          ? "#D2DE32"

          : "inherit",

      },

      onDoubleClick: () => handleRowDoubleClick(rowIndex),

    }),

  };

  const classes = useStyles();



  const handleRowDoubleClick = (rowIndex) => {

    const updatedSelectedRows = [...selectedRows];

    const rowIndexInSelectedRows = updatedSelectedRows.indexOf(rowIndex);

    if (rowIndexInSelectedRows === -1) {

      updatedSelectedRows.push(rowIndex);

    } else {

      updatedSelectedRows.splice(rowIndexInSelectedRows, 1);

    }

    setSelectedRows(updatedSelectedRows);

  };



  const handleSelectedRowsCount = () => {

    return selectedRows.length;

  };

  const handleCloseSnackbar = (event, reason) => {

    if (reason === "clickaway") {

      return;

    }

    setSnackbarOpen(false);

  };

  const handleCellChange = (rowIndex, field, value) => {

    setEditedRows((prev) => ({

      ...prev,

      [rowIndex]: {

        ...data[rowIndex],

        ...(prev[rowIndex] || {}),

        [field]: value,

      },

    }));

  };



  const exportSelectedRowsToCSV = () => {

    const selectedData = selectedRows.map((index) => {

      const row = {

        ...data[index],

        ...(editedRows[index] || {}),

      };



      return {

        "First Name": row.first_name || "",

        "Last Name": row.last_name || "",

        Mobile: row.mobile || "",

        State: row.state || "",

        City: row.city || "",

        "Campaign ID": row.campaign_id || "",

        Brand: row.brand_name || "",

        "Model Name": row.modelName || selectedModel?.title || "",

        Date: row.created_at || "",

      };

    });



    if (selectedData.length === 0) {

      setSnackbarMessage("Please select at least one row");

      setSnackbarOpen(true);

      return;

    }



    const headers = Object.keys(selectedData[0]);



    const csvRows = [

      headers.join(","),

      ...selectedData.map((row) =>

        headers.map((header) => `"${row[header] ?? ""}"`).join(","),

      ),

    ];



    const csvContent = csvRows.join("\n");



    const blob = new Blob([csvContent], {

      type: "text/csv;charset=utf-8;",

    });



    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.setAttribute(

      "download",

      `SocialCampaigns_${new Date().toISOString().split("T")[0]}.csv`,

    );

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

  };



  const tableColumns = ["1", "2", "3", "4"].includes(moveType)

    ? columnsEdittable

    : columns;



  useEffect(() => {

    if (!selectedModel?.title) return;

    setData((prevData) =>

      prevData.map((row) => ({

        ...row,

        modelName: selectedModel.title,

      })),

    );

  }, [selectedModel]);



  useEffect(() => {

    setSelectedRows([]);

    setEditedRows({});

  }, [

    selectedCampaign,

    selectedBrand,

    selectedModel,

    selectedState,

    selectedProject,

    isVerified,

    moveType,

    fromDate,

    toDate,

    page,

    perPage,

  ]);

  return (

    <>

      <div>

        <Snackbar

          anchorOrigin={{

            vertical: "top",

            horizontal: "right",

          }}

          open={snackbarOpen}

          autoHideDuration={6000}

          onClose={handleCloseSnackbar}

        >

          <MuiAlert

            onClose={handleCloseSnackbar}

            severity={snackbarSeverity}

            sx={{ width: "100%" }}

            variant="filled"

          >

            {snackbarMessage}

          </MuiAlert>

        </Snackbar>

      </div>



      <Box sx={{ width: "100%" }}>

        <Grid container>

          <Grid item xs={6} style={{ marginTop: "8px" }}>

            <Typography

              className={classNames(

                classes.pagetittle,

                classes.pagetittlestyle,

              )}

            >

              Social Campaigns Report

            </Typography>

          </Grid>

        </Grid>

        <hr className={classes.horizontalline} />

      </Box>

      <div className={classes.root}>

        <div className={classes.root}>

          <Grid container spacing={1} alignItems="center">

            <Grid item xs={4} sm={2} lg={2}>

              <input

                type="date"

                name="fromDate"

                value={fromDate}

                onChange={handleDateChange}

                className={classes.inputform}

              />

            </Grid>



            <Grid item xs={4} sm={2} lg={2}>

              <input

                className={classes.inputform}

                type="date"

                name="toDate"

                value={toDate}

                onChange={handleDateChange}

              />

            </Grid>



            <Grid item xs={4} sm={2} lg={4}>

              <Autocomplete

                renderTags={(value) =>

                  value.map((option) => option.title).join(", ")

                }

                multiple

                classes={{

                  option: classes.autocompleteoption,

                }}

                options={brandOptions}

                getOptionLabel={(option) => option.title}

                renderInput={(params) => (

                  <TextField

                    {...params}

                    placeholder="Select brand"

                    variant="outlined"

                  />

                )}

                value={selectedBrand}

                onChange={handleBrandChange}

                disableCloseOnSelect

                isOptionEqualToValue={(option, value) => option.id === value.id}

                getOptionSelected={(option, value) => option.id === value.id}

                renderOption={(props, option, { selected }) => (

                  <li {...props}>

                    <Checkbox

                      checked={selected}

                      size="small"

                      style={{ marginRight: 0 }}

                    />

                    {option.title}

                  </li>

                )}

              />

            </Grid>



            <Grid item xs={4} sm={2} lg={2}>

              <Autocomplete

                classes={{

                  option: classes.autocompleteoption,

                }}

                options={modelOptions}

                getOptionLabel={(option) => option.title || ""}

                renderInput={(params) => (

                  <TextField

                    {...params}

                    placeholder="Select Model"

                    variant="outlined"

                  />

                )}

                value={selectedModel}

                onChange={(event, newValue) => setSelectedModel(newValue)}

                disableCloseOnSelect

                isOptionEqualToValue={(option, value) => option.id === value.id}

                getOptionSelected={(option, value) => option.id === value.id}

                renderOption={(props, option) => (

                  <li {...props}>{option.title}</li>

                )}

              />

            </Grid>



            <Grid item xs={4} sm={2} lg={2}>

              <Autocomplete

                classes={{

                  option: classes.autocompleteoption,

                }}

                options={stateOptions}

                getOptionLabel={(option) => option.title}

                renderInput={(params) => (

                  <TextField

                    {...params}

                    placeholder="Select State"

                    variant="outlined"

                  />

                )}

                value={selectedState}

                onChange={handleStateChange}

                disableCloseOnSelect

                isOptionEqualToValue={(option, value) => option.id === value.id}

                getOptionSelected={(option, value) => option.id === value.id}

                renderOption={(props, option, { selected }) => (

                  <li {...props}>{option.title}</li>

                )}

              />

            </Grid>

            <Grid item xs={4} sm={2} lg={2}>

              <Autocomplete

                classes={{

                  option: classes.autocompleteoption,

                }}

                options={projectOptions}

                getOptionLabel={(option) => option.title || ""}

                renderInput={(params) => (

                  <TextField

                    {...params}

                    placeholder="Select Project Name"

                    variant="outlined"

                  />

                )}

                value={selectedProject}

                onChange={handleProjectChange}

                disableCloseOnSelect

                isOptionEqualToValue={(option, value) => option.id === value.id}

                getOptionSelected={(option, value) => option.id === value.id}

                renderOption={(props, option) => (

                  <li {...props}>{option.title}</li>

                )}

              />

            </Grid>

            <Grid item xs={4} sm={2} lg={2}>

              <select

                className={classes.selectform}

                value={isVerified}

                onChange={(e) => setIsVerified(e.target.value)}

              >

                <option value="">Select Lead type</option>

                <option value="raw">Raw</option>

                <option value="verified">Verified</option>

              </select>

            </Grid>

            <Grid item xs={4} sm={2} lg={2}>

              <select

                className={classes.selectform}

                value={moveType}

                onChange={(e) => {

                  const value = e.target.value;

                  setMoveType(value);
                if (value !== "3") {
                  setIsLoan(false);
                  setLoanType("");
                  setClientName("");
                }

                  if (value !== "3") {

                    setSelectedLeadSource("");

                  }

                }}

              >

                <option value="">Select Option</option>

                <option value="1">Move To All Enquiries</option>

                <option value="2">Download and Supplier</option>

                <option value="3">Move To API</option>

              </select>

            </Grid>

            {moveType === "3" && (
            <Grid item xs={4} sm={2} lg={2}>
              <div style={{ display: "flex", alignItems: "center", minHeight: "40px" }}>
                <Checkbox
                  checked={isLoan}
                  onChange={(e) => {
                    setIsLoan(e.target.checked);
                    if (!e.target.checked) {
                      setLoanType("");
                      setClientName("");
                    }
                  }}
                  size="small"
                />
                <Typography variant="body2">Is Loan</Typography>
              </div>
            </Grid>
          )}
          {moveType === "3" && isLoan && (
            <>
              <Grid item xs={4} sm={2} lg={2}>
                <select className={classes.selectform} value={loanType} onChange={(e) => setLoanType(e.target.value)}>
                  <option value="">Select Loan Type</option>
                  <option value="loan">Loan</option>
                  <option value="finance">Finance</option>
                </select>
              </Grid>
              <Grid item xs={4} sm={2} lg={2}>
                <select className={classes.selectform} value={clientName} onChange={(e) => setClientName(e.target.value)}>
                  <option value="">Select Client Name</option>
                  <option value="tyger">Tyger</option>
                </select>
              </Grid>
            </>
          )}
          {showLeadSource && (

              <Grid item xs={4} sm={2} lg={2}>

                <select

                  className={classes.selectform}

                  value={selectedLeadSource}

                  onChange={(e) => setSelectedLeadSource(e.target.value)}

                >

                  <option value="">Select Lead Source</option>

                  {sourceCodeOptions.map((option) => (

                    <option key={option.id} value={option.id}>

                      {option.title}

                    </option>

                  ))}

                </select>

              </Grid>

            )}



            <Grid item xs={4} sm={2} lg={2}>

              <div

                style={{

                  display: "flex",

                  alignItems: "center",

                  height: "100%",

                  minHeight: "40px",

                }}

              >

                <Checkbox

                  checked={changeBrand}

                  onChange={(e) => {

                    const checked = e.target.checked;

                    setChangeBrand(checked);

                    if (!checked) {

                      setChangeBrandId(null);

                    }

                  }}

                  size="small"

                />

                <Typography variant="body2">Change Brand</Typography>

              </div>

            </Grid>

            {changeBrand && (

              <Grid item xs={4} sm={2} lg={2}>

                <Autocomplete

                  classes={{

                    option: classes.autocompleteoption,

                  }}

                  options={brandOptions}

                  getOptionLabel={(option) => option.title || ""}

                  renderInput={(params) => (

                    <TextField

                      {...params}

                      placeholder="Change Brand To"

                      variant="outlined"

                    />

                  )}

                  value={changeBrandId}

                  onChange={(event, newValue) => setChangeBrandId(newValue)}

                  isOptionEqualToValue={(option, value) => option.id === value.id}

                  getOptionSelected={(option, value) => option.id === value.id}

                  renderOption={(props, option) => (

                    <li {...props}>{option.title}</li>

                  )}

                />

              </Grid>

            )}



            <Grid item xs={12} sm={12} lg={showLeadSource ? 4 : 6}>

              <div

                style={{

                  display: "flex",

                  justifyContent: "flex-start",

                  alignItems: "center",

                  gap: "10px",

                  width: "100%",

                  flexWrap: "wrap",

                }}

              >

                <Button

                  onClick={handleResetFields}

                  variant="outlined"

                  startIcon={<ClearIcon />}

                  style={{

                    backgroundColor: "#dc3545",

                    borderColor: "#dc3545",

                  }}

                  className={classes.buttonform}

                >

                  Reset Fields

                </Button>

                <Button

                  onClick={handleDataLoaded}

                  variant="contained"

                  startIcon={

                    isLoading ? (

                      <CircularProgress size={18} style={{ color: "inherit" }} />

                    ) : isDataLoaded ? (

                      <CheckCircleIcon />

                    ) : (

                      <CloudDownloadIcon />

                    )

                  }

                  disabled={isLoading}

                  style={{

                    backgroundColor: "#1976d2",

                    borderColor: "#1976d2",

                    color: "#fff",

                  }}

                  className={classes.buttonform}

                >

                  {isLoading

                    ? "Loading..."

                    : isDataLoaded

                      ? "Data Loaded"

                      : "Get Data"}

                </Button>

                <Button variant="contained" onClick={() => setOpenBrandTargetPopup(true)} style={{

                      backgroundColor: "#123d79", color: "#fff", }}>

                    Brand Target Report

                </Button>

                <Button

                  disabled={

                    isLoading || !isDataLoaded || selectedRows.length === 0

                  }

                  onClick={handleMoveEnquiryClick}

                  style={{ backgroundColor: "#1976d2", borderColor: "#1976d2" }}

                  className={classes.buttonform}

                  variant="outlined"

                  startIcon={<AssignmentIndIcon />}

                >

                  <span>{handleSelectedRowsCount()}</span>-Move Enquiry

                </Button>

              </div>

            </Grid>

          </Grid>

        </div>

      </div>

      <br />



      <MuiThemeProvider theme={customTheme()}>

        {isLoading ? <LinearProgress /> : ""}

        <MUIDataTable

          title={

            isLoading ? (

              <Skeleton animation="wave" />

            ) : (

              <Typography className={classes.tabletittle}>

                {selectedRows.length > 0 && (

                  <span>Selected Records : {selectedRows.length}</span>

                )}

              </Typography>

            )

          }

          data={data}

          options={options}

          columns={tableColumns}

        />

      </MuiThemeProvider>

      <Drawer

        anchor="right"

        open={openSidebar}

        PaperProps={{

          style: {

            width: "100%",

            maxWidth: 300,

            padding: "10px",

          },

        }}

        onClose={() => setOpenSidebar(false)}

      >

        <form onSubmit={handleSubmit}>

          <Grid container spacing={1}>

            <Grid

              item

              xs={4}

              sm={2}

              lg={12}

              style={{ textAlign: "right", cursor: "pointer" }}

            >

              <ClearIcon

                style={{ color: "#c0392b" }}

                onClick={() => setOpenSidebar(false)}

              />

            </Grid>

            <Grid item xs={4} sm={2} lg={12}>

              <br />

              <Typography className={classes.tabletittle}>Filter</Typography>

            </Grid>

          </Grid>

          <div

            className={classes.root}

            style={{ paddingRight: "22px", paddingLeft: "22px" }}

          >

            <div className={classes.root}>

              <Grid container spacing={1}>

                <Grid item xs={12} sm={12} lg={12}>

                  <Autocomplete

                    renderTags={(value) =>

                      value.map((option) => option.title).join(", ")

                    }

                    multiple

                    classes={{

                      option: classes.autocompleteoption,

                    }}

                    options={campaignOptions}

                    getOptionLabel={(option) => option.title || ""}

                    value={selectedCampaign}

                    onChange={(event, newValue) => {

                      setSelectedCampaign(newValue);

                    }}

                    disableCloseOnSelect

                    isOptionEqualToValue={(option, value) =>

                      option.id === value.id

                    }

                    renderInput={(params) => (

                      <TextField

                        {...params}

                        placeholder="Campaign ID"

                        variant="outlined"

                      />

                    )}

                    renderOption={(props, option, { selected }) => (

                      <li {...props}>

                        <Checkbox

                          checked={selected}

                          size="small"

                          style={{ marginRight: 0 }}

                        />

                        {option.title}

                      </li>

                    )}

                  />

                </Grid>

                <Grid item xs={12} sm={12} lg={12}>

                  <Autocomplete

                    renderTags={(value) =>

                      value.map((option) => option.title).join(", ")

                    }

                    multiple

                    classes={{

                      option: classes.autocompleteoption,

                    }}

                    options={brandOptions}

                    getOptionLabel={(option) => option.title}

                    renderInput={(params) => (

                      <TextField

                        {...params}

                        placeholder="Select brand"

                        variant="outlined"

                      />

                    )}

                    value={selectedBrand}

                    onChange={handleBrandChange}

                    disableCloseOnSelect

                    isOptionEqualToValue={(option, value) =>

                      option.id === value.id

                    }

                    getOptionSelected={(option, value) =>

                      option.id === value.id

                    }

                    renderOption={(props, option, { selected }) => (

                      <li {...props}>

                        <Checkbox

                          checked={selected}

                          size="small"

                          style={{ marginRight: 0 }}

                        />

                        {option.title}

                      </li>

                    )}

                  />

                </Grid>

                <Grid item xs={12} sm={12} lg={12}>

                  <Autocomplete

                    classes={{

                      option: classes.autocompleteoption,

                    }}

                    options={stateOptions}

                    getOptionLabel={(option) => option.title}

                    renderInput={(params) => (

                      <TextField

                        {...params}

                        placeholder="Select State"

                        variant="outlined"

                      />

                    )}

                    value={selectedState}

                    onChange={handleStateChange}

                    disableCloseOnSelect

                    isOptionEqualToValue={(option, value) =>

                      option.id === value.id

                    }

                    getOptionSelected={(option, value) =>

                      option.id === value.id

                    }

                    renderOption={(props, option, { selected }) => (

                      <li {...props}>{option.title}</li>

                    )}

                  />

                </Grid>

                <Grid item xs={12}>

                  <input

                    className={classes.inputform}

                    type="date"

                    name="fromDate"

                    value={fromDate}

                    onChange={handleDateChange}

                  />

                </Grid>

                <Grid item xs={12}>

                  <input

                    className={classes.inputform}

                    type="date"

                    name="toDate"

                    value={toDate}

                    onChange={handleDateChange}

                  />

                </Grid>

                <Grid item xs={12}>

                  <select

                    className={classes.inputform}

                    value={isVerified}

                    onChange={(e) => setIsVerified(e.target.value)}

                  >

                    <option value="">Verification</option>

                    <option value="verified">Verified</option>

                    <option value="unverified">Unverified</option>

                  </select>

                </Grid>

              </Grid>

            </div>

          </div>

          <br />

          <Grid>

            <Grid

              item

              xs={4}

              sm={2}

              lg={12}

              style={{ margin: "auto", padding: "auto", textAlign: "center" }}

            >

              <Button

                type="submit"

                style={{ marginRight: "10px" }}

                className={classes.buttonform}

                variant="outlined"

                startIcon={<ApprovalIcon />}

              >

                Apply

              </Button>

              <Button

                type="button"

                onClick={clearForm}

                style={{ backgroundColor: "#dc3545", borderColor: "#dc3545" }}

                className={classes.buttonform}

                variant="outlined"

                startIcon={<ClearIcon />}

              >

                Clear

              </Button>

            </Grid>

          </Grid>

          <br />

        </form>

      </Drawer>

      <Modal open={openConfirmModal} onClose={() => setOpenConfirmModal(false)}>

        <Box

          sx={{

            position: "absolute",

            top: "50%",

            left: "50%",

            transform: "translate(-50%, -50%)",

            bgcolor: "background.paper",

            p: 3,

            borderRadius: 2,

            minWidth: 450,

            textAlign: "center",

            boxShadow: 24,

          }}

        >

          <Typography

            variant="h6"

            gutterBottom

            style={{

              fontWeight: 600,

              color: "#1976d2",

            }}

          >

            Move To Enquiry Confirmation

          </Typography>

          <Typography

            variant="body1"

            style={{

              marginBottom: "20px",

            }}

          >

            Are you sure you want to move

            <b> {selectedRows.length} </b>

            selected enquiry records?

          </Typography>



          <div

            style={{

              display: "flex",

              justifyContent: "center",

              gap: "10px",

              flexWrap: "wrap",

            }}

          >

            <Button

              variant="contained"

              color="primary"

              onClick={handleConfirmSubmit}

              disabled={isLoading}

            >

              {isLoading ? "Processing..." : "Yes, Move Enquiry"}

            </Button>



            <Button

              variant="contained"

              style={{

                backgroundColor: "#28a745",

                color: "#fff",

              }}

              onClick={() => {

                exportSelectedRowsToCSV();

                setOpenConfirmModal(false);

              }}

            >

              Export Selected CSV

            </Button>



            <Button

              variant="outlined"

              color="secondary"

              onClick={() => setOpenConfirmModal(false)}

            >

              Cancel

            </Button>

          </div>

        </Box>

      </Modal>

      {/* @@@@@@@@@@@@@@@@@@@@@@@ view model start */}

      <Modal open={openViewModal} onClose={() => setOpenViewModal(false)}>

        <Box

          sx={{

            position: "absolute",

            top: "50%",

            left: "50%",

            transform: "translate(-50%, -50%)",

            bgcolor: "#fff",

            p: 3,

            borderRadius: 2,

            width: 900,

            height: "95vh",

            overflowY: "auto",

            boxShadow: 24,

          }}

        >

          <div

            style={{

              display: "flex",

              justifyContent: "space-between",

              alignItems: "center",

              marginBottom: "20px",

              borderBottom: "1px solid #e0e0e0",

              paddingBottom: "10px",

            }}

          >

            <Typography

              variant="h6"

              style={{

                fontWeight: 600,

                color: "#1976d2",

                margin: 0,

              }}

            >

              Enquiry Details

            </Typography>



            <IconButton

              onClick={() => setOpenViewModal(false)}

              size="small"

              style={{

                color: "#f44336",

                backgroundColor: "#f5f5f5",

              }}

            >

              <CloseIcon />

            </IconButton>

          </div>



          {viewRowData && (

            <Grid container spacing={2}>

              <Grid item xs={6}>

                <span className={classes.breadcrumbslinkHightlight}>

                  First Name <span>:</span>

                </span>{" "}

                {viewRowData.first_name}

              </Grid>



              <Grid item xs={6}>

                <span className={classes.breadcrumbslinkHightlight}>

                  Last Name <span>:</span>

                </span>{" "}

                {viewRowData.last_name}

              </Grid>



              <Grid item xs={6}>

                <span className={classes.breadcrumbslinkHightlight}>

                  Mobile <span>:</span>

                </span>{" "}

                {viewRowData.mobile}

              </Grid>



              <Grid item xs={6}>

                <span className={classes.breadcrumbslinkHightlight}>

                  Brand <span>:</span>

                </span>{" "}

                {viewRowData.brand_name}

              </Grid>



              <Grid item xs={6}>

                <span className={classes.breadcrumbslinkHightlight}>

                  State <span>:</span>

                </span>{" "}

                {viewRowData.state}

              </Grid>



              <Grid item xs={6}>

                <span className={classes.breadcrumbslinkHightlight}>

                  City <span>:</span>

                </span>{" "}

                {viewRowData.city}

              </Grid>



              <Grid item xs={12}>

                <span className={classes.breadcrumbslinkHightlight}>

                  Source <span>:</span>

                </span>{" "}

                FBE

              </Grid>



              <Grid item xs={6}>

                <span className={classes.breadcrumbslinkHightlight}>

                  Date <span>:</span>

                </span>{" "}

                {viewRowData.created_at}

              </Grid>

            </Grid>

          )}
        </Box>

      </Modal>
      {/* @@@@@@@@@@@@@@@@@@@@@@@ view model end */}

      {brandTargetLoading && openBrandTargetPopup && <Typography>Loading brand target report...</Typography>}
      {brandTargetError && openBrandTargetPopup && <Typography color="error">{brandTargetError}</Typography>}
      <BrandTargetReportPopup
        open={openBrandTargetPopup}
        onClose={() => setOpenBrandTargetPopup(false)}
        reportData={brandTargetResponse}

      />
    </>
  );

};

export default SocialCampaigns;

const inputStyle = {

  width: "100%",

  minWidth: "150px",

  boxSizing: "border-box",

  padding: "8px",

  border: "1px solid #ccc",

  borderRadius: "4px",

};